"use client"

import { useEffect, useState } from "react"
import { Button } from "@/components/ui/button"
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card"
import { Alert, AlertDescription } from "@/components/ui/alert"

import { loginRequest } from "@/lib/msal-config"
import { useIsAuthenticated, useMsal } from "@azure/msal-react"
import { useNavigate } from "react-router"


export const LoginCard : React.FC = () => {
  const { instance } = useMsal();
  const [error, setError] = useState("")
  const isAuthenticated = useIsAuthenticated();
  const navigate = useNavigate();
  const handleLogin = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    instance.loginRedirect(loginRequest).catch((error: any) => {
      console.error("Login failed:", error);
      setError('Error logging in')
    });
  };

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, [isAuthenticated, navigate])

  return (
    <div className="min-h-screen bg-linear-to-br from-blue-50 to-indigo-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <div className="mx-auto mb-4 flex items-center justify-center rounded-full bg-blue-100">
            <img src="/img/logo-login.png" alt="BioGain Logo" width="75" height="75" />
          </div>
          <CardTitle className="text-2xl font-bold biogain-green">BioGain™</CardTitle>
          <CardDescription>Making land management easier, more effective and sustainable</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {error && (
            <Alert variant="destructive">
              <AlertDescription>{error}</AlertDescription>
            </Alert>
          )}
          <div className="flex items-center justify-center">
            <Button onClick={handleLogin} className="biogain-background-green text-xl cursor-pointer">
              Sign in
            </Button>
          </div>

          <div className="flex items-center justify-around">
            <a className="biogain-green" title="privacy policy" href="https://www.biogain.ai/english-privacy-policy" target="_blank">Privacy Policy</a>
            <a className="biogain-green" title="terms of use" href="https://www.biogain.ai/terms-of-use" target="_blank">Terms of Use</a>
          </div>
          
          {/* <Button onClick={handleLogin} className="w-full" disabled={loading || isLoggingIn}>
            {loading || isLoggingIn ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Signing in...
              </>
            ) : (
              "Sign in with Microsoft"
            )}
          </Button> */}

        </CardContent>
      </Card>
    </div>
  )
}
